import { render, staticRenderFns } from "./CPTemp6.vue?vue&type=template&id=5c197d7a&scoped=true&"
import script from "./CPTemp6.vue?vue&type=script&lang=js&"
export * from "./CPTemp6.vue?vue&type=script&lang=js&"
import style0 from "./CPTemp6.vue?vue&type=style&index=0&id=5c197d7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c197d7a",
  null
  
)

export default component.exports